import React from 'react';
import InputMask from 'react-input-mask';

const PhoneInput = (props) => {
  return (
    <InputMask
      {...props}
      mask='+54 9999 9999 999'
      maskChar=' '
      placeholder={props.placeholder ? props.placeholder : ''}
    />
  );
};

export default PhoneInput;
